import useEmotionStyles from "@styles/shared/useEmotionStyles";
import { MarkFeedbackStyle } from "@styles/assignments/MarkFeedbackStyle";
import { RubricTable as CommonRubricTable } from "@components/common/RubricTable";

export const RubricTable = (props) => {
	const classes = useEmotionStyles(MarkFeedbackStyle);
	const { rubricInfo } = props;

	return (
		<CommonRubricTable
			rubricInfo={rubricInfo}
			variant="scoring"
			classes={classes}
		/>
	);
};
